















































































































































import {Component, Prop, Watch} from 'vue-property-decorator';
import Form from '@/components/form-base';
import { DialogForm, FormOverlay, CardForm } from '@/components/bwaff';
import Template from '@/views/reports/forms/traffic_sources/template.vue';
import CampaignApi from '@/services/rest/bemob/campaign';
import { StatusEnum } from '@/services/models/Enums';
import DomainsApi from '@/services/rest/bemob/domains';
import AffiliateNetworkAPI from '@/services/rest/bemob/affiliate-network';
import { mixins } from 'vue-class-component';
import ReportMixin from '@/views/reports/mixins/report-mixin';

@Component({
  components: {
    Template,
    FormOverlay,
    DialogForm,
    CardForm,
  }
})
export default class GenerateLinks extends mixins<Form,ReportMixin>(Form,ReportMixin) {
  @Prop({ default: {} })
  data: any;

  campaignApi: CampaignApi = new CampaignApi();
  affiliateNetworkApi: AffiliateNetworkAPI = new AffiliateNetworkAPI();
  domainsApi: DomainsApi = new DomainsApi();

  show: boolean = false;
  campaignsLoading: boolean = true;

  allCampaigns:any = [];
  selectedCampaign:any = '';

  item:any = {};
  selectedWorkspaceId:string = ''

  selectedCET:'';
  selectedAffiliateNetworks:any = {};

  form:any = {
    clickId:'',
    payout:'',
    transactionId:'',
    cet:''
  };

  role:('enterManually'|'fromAffiliateNetwork') = 'enterManually'

  get workspacesList() {
    return this.$store.getters.allPrivateWorkspaces;
  }

  get s2sPostback(){
    return `${this.domain}/postback${this.urlParams('REPLACE')}`
  }

  get conversionPixelURL(){
    return `${this.domain}/conversion.gif${this.urlParams('OPTIONAL')}`
  }

  get conversionPixel(){
    return `<img src="${this.domain}/conversion.gif${this.urlParams('OPTIONAL')}" width="1" height="1" border="0" alt="" />`
  }

  get conversionScript(){
    return `<sc${''}ript async type="text/javascript" src="${this.domain}/conversion.js${this.urlParams('OPTIONAL')}"></sc${''}ript>`
  }

  get conversionPixelURLTxt(){  
    return `${this.domain}/conversion.txt${this.urlParams('OPTIONAL')}`
  }

  urlParams(clickIdDefault){
    const cet = `cet=${this.form.cet}`;
    const cid = `cid=${this.form.clickId || clickIdDefault}`;
    const payout = `payout=${this.form.payout||'OPTIONAL'}`;
    const txid = `txid=${this.form.transactionId || 'OPTIONAL'}`;
    return `?${cet}&${cid}&${payout}&${txid}`
  }

  get domain(){
    if(!this.selectedCampaign) return 'https://yourdomain.com/';
    const trackingDomainIdFromCompany = this.$store.getters.cache.trackingDomainsObject[this.selectedCampaign.trackingDomainId]

    const trackingDomain =  this.$store.getters.cache.trackingDomainsObject[this.selectedCampaign.trackingDomainId] ||
         this.$store.getters.cache.trackingDomainsObject[this.$store.state.user.trackingDomainId]

    return trackingDomain
      ? (trackingDomain.httpsAvailable ? 'https' : 'http') + '://' + trackingDomain.domain : 'https://yourdomain.com/'
  }

  async mounted() {
    this.selectedWorkspaceId = this.defaultWorkspace?.id
    
    if(!this.$store.state.cache.trackingDomains.isUploaded){
      await this.domainsApi.trackingDomainsPopulateStoreCache()
    }

    if(!this.$store.state.cache.affiliateNetworks.isUploaded){
      await this.affiliateNetworkApi.populateStoreCache()
    }

    if(!this.$store.state.cache.campaigns.isUploaded){
      await this.campaignApi.populateStoreCache()
    }
    this.setCampaignOptions()

    this.item = this.data;
    this.form.cet = this.item.values[0]
    this.show = true;
    this.$store.commit('loading', false);
  }

  close() {
    this.$emit('close');
  }

  onChangeWorkspace(value: any) {
    this.selectedWorkspaceId = value;
    this.setCampaignOptions()
  }

  get getAllAffiliateNetworks() {
    return this.$store.state.cache.affiliateNetworks.data.filter((item)=>this.$store.getters.allWorkspacesObject[item.workspaceId]?.type === 'public' || item.workspaceId === this.selectedWorkspaceId)
  }

  setCampaignOptions() {
    const {isAllInCache, data, isUploaded, uploadedForWorkspace} = this.$store.state.cache.campaigns;

    if(isUploaded && isAllInCache) {
      const campaigns = data.filter(item => item.workspaceId === this.selectedWorkspaceId)
      this.allCampaigns = campaigns
      this.selectedCampaign = campaigns[0];
      this.campaignsLoading = false;
      return;
    }

    if(isUploaded && !isAllInCache && uploadedForWorkspace === this.selectedWorkspaceId){
      this.allCampaigns = data
      this.selectedCampaign = data[0]
      this.campaignsLoading = false;
      return;
    }

    if(this.selectedWorkspaceId === this.defaultWorkspace.id){
      return this.campaignApi.updateStoreCache({
        workspaceId: this.selectedWorkspaceId,
      }).then((res:Campaign[])=>{
        this.allCampaigns = res
        this.selectedCampaign = res[0]
        this.campaignsLoading = false;
      })
    }

    return this.campaignApi.getList({
      status:StatusEnum.active,
      limit:200,
      orderBy:'updated',
      orderDirection:'desc',
      workspaceIds:[this.selectedWorkspaceId]
    }).then((res:Campaign[])=>{
      this.allCampaigns = res
      this.selectedCampaign = this.allCampaigns[0]
      this.campaignsLoading = false;
    })
  }

  @Watch('role')
  campaignChanged() {
    if(this.role ==='fromAffiliateNetwork'){
      this.updateFromAffiliateNetwork()
    }else{
      this.form={
        ...this.form,
        clickId:'',
        payout:'',
        transactionId:''
      }
    }
  }

  updateFromAffiliateNetwork() {
    const template = this.selectedAffiliateNetworks?.affiliateNetworkTemplate;
    this.form = {
      ...this.form,
      clickId: template?.clickIdPlaceholder,
      payout: template?.payoutPlaceholder,
      transactionId: template?.transactionIdPlaceholder
    }
  }

  @Watch('selectedAffiliateNetworks')
  selectedAffiliateNetworksChanged() {
    if(this.role ==='fromAffiliateNetwork'){
      this.updateFromAffiliateNetwork()
    }
  }

  get fetchCampaignOptions(){
    if(this.$store.state.cache.campaigns.isAllInCache){
      return
    }
    return ({ search })=>this.campaignApi.getList({
      status: StatusEnum.active,
      search,
      limit:200,
      orderBy:'updated',
      orderDirection:'desc',
      workspaceIds:[this.selectedWorkspaceId]
    }).then((res)=>{
      return res
    })
  }
}
